import axios from "axios";

// Expected to have the string "{project}" in which to place the project name
const provided_db_url = process.env.REACT_APP_DB_URL;

// Choose DB URL
const db_url = new URL(provided_db_url).toString();

const insertProjectName = (url, project) => url.replace(/\{project\}/, project);

// Append project path parameter for formatting
function get_db_base(project) {
  return insertProjectName(unescape(db_url), project);
}

const request_items = (
  db_base,
  collection,
  collection_name_override,
  is_single,
  fields_to_get,
  filter
) => {
  var collection_path = collection;
  var fields = "?fields=" + fields_to_get;
  var filter_path = filter ? "&" + filter : "";
  var path = collection_path + fields + filter_path + "&limit=-1";
  return axios.get(db_base + "items/" + path).then((result) => {
    return result.data.data;
  });
};

export { get_db_base, request_items };
